<app-navbar></app-navbar>

<div class="appointment-confirmation-container">
  <div class="confirmation-content">

    <div class="confirmation-header">
    
      <h1 class="confirmation-title">  <div class="checkmark-icon"> <img src="/checkmark.png"/>  </div>Your Appointment Is Confirmed!</h1>
      <p class="appointment-details">Scheduled for {{ appointmentDate }} at {{ appointmentTime }}{{ appointmentProvider ? (' with ' + appointmentProvider) : '' }}</p>
    </div>

    <div *ngIf="showNoShowPolicy" class="scheduled-no-show-policy">
      <div class="scheduled-no-show-policy-title">
        <img class="scheduled-no-show-policy-icon" src="Info.png" alt="" />
        <span>Cancellation &amp; No-Show Policy</span>
      </div>
      <p>We require at least <strong>48 hours'</strong> notice to cancel or reschedule your appointment.</p>
      <p>Missed or canceled appointments with less than <strong>48 hours'</strong> notice are subject to a no-show <strong>fee starting at $50.</strong> This fee is billed to you and is not covered by insurance.</p>
    </div>

  
    <div class="steps-section">
      <div class="section-header">
        <span class="clipboard-icon"><img src="/notebook.png"/></span>
        <h2 class=>Steps to Complete Before Your Visit:</h2>
      </div>

      <div class="steps-list">
        <div class="step-item">
          <div class="step-number">1.</div>
          <div class="step-content">
            <h3>Create Your Patient Portal Account</h3>
            <ul class="step-list">
              <li>To get started, register here: 
                <a 
                  href="https://pp-wfe-100.advancedmd.com/149583/account/logon" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  style="font-size: 14px;" 
                  class="portal-link">[AdvancedMD | Patient Portal]</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="step-item">
          <div class="step-number">2.</div>
          <div class="step-content">
            <h3>Complete Required Forms</h3>
            <ul class="step-list">
              <li>You'll find consent, policy, and intake forms in the portal.</li>
              <li>Please submit all forms <strong>before</strong> your scheduled appointment to avoid delays.</li>
            </ul>
          </div>
        </div>

        <div class="step-item">
          <div class="step-number">3.</div>
          <div class="step-content">
            <h3>Insurance Information (If applicable)</h3>
            <ul class="step-list">
              <li>Upload <strong>clear photos of the front and back </strong>of your insurance card via the patient portal or email to: 
               <a href="mailto:Hope@Animosanopsychiatry.com" class="email-link">Hope&#64;Animosanopsychiatry.com</a>.</li>
              <li>Once uploaded, <strong>send a portal message</strong> to the Q&A group to notify our team.</li>
            </ul>
          </div>
        </div>

        <div class="step-item">
          <div class="step-number">4.</div>
          <div class="step-content">
            <h3>Share Medical Records (If Available)</h3>
            <ul class="step-list">
              <li>Download records from your previous provider's portal, if applicable.</li>
              <li>Upload them to your portal account or email to: 
               <a href="mailto:Hope@Animosanopsychiatry.com" class="email-link">Hope&#64;Animosanopsychiatry.com</a></li>
              <li>This helps us better understand your medical history and offer personalized care.</li>
            </ul>
          </div>
        </div>

        <div class="step-item">
          <div class="step-number">5.</div>
          <div class="step-content">
            <h3>Bring Valid ID for Verification</h3>
            <ul class="step-list">
              <li>A valid photo ID is required to confirm your identity at the time of your appointment.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>


    <div class="visit-day-section">
      <div class="section-header">
        <span class="calendar-icon"><img src="/notepad.png"/></span>
        <h2>On the Day of Your Visit</h2>
      </div>

      <div class="visit-options">
        <div class="virtual-appointments">
          <h3>Virtual Appointments</h3>
            <ul class="step-list">
              <li>
                Log in <strong><span class="">15 minutes early</span></strong> using this link: 
                <a 
                  href="https://appointments.myasp.care/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  class="telehealth-link">Telehealth Visit</a>
              </li>
              <li>This ensures time for check-in and tech troubleshooting.</li>
            </ul>
        </div>

        <!-- <div class="cancellations">
          <h3>Cancellations & Rescheduling</h3>
          <ul class="step-list">
            <li>Need to reschedule? Kindly give us <span class="hours-notice">at least 48 hours' notice</span> to avoid a no-show fee.</li>
          </ul>
        </div> -->
      </div>
    </div>


    <div class="help-section">
      <h2>Need Help?</h2>
      <div class="contact-info">
        <p class="contact-line">
          <span class="phone-icon"><i class="fa-solid fa-phone"></i></span>
          <span class="contact-right"><span class="contact-label">Call Us:</span> <a href="tel:919-391-7202" class="phone-link">919-391-7202</a></span>
        </p>
        <p class="contact-line">
          <span class="email-icon"><i class="fa-solid fa-envelope"></i></span>
          <span class="contact-right"><span class="contact-label">Email:</span> <a href="mailto:hope@animosanopsychiatry.com" class="email-link">hope&#64;animosanopsychiatry.com</a></span>
        </p>
      </div>
    </div>


    <div class="support-message">
      <p>We're here to support you—every step of the way.</p>
    </div>
  </div>
</div>

<app-footer></app-footer>
